import { Button, Link } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';
import { useDocumentPreview } from '../../../hooks/useDocumentPreview';

const ShoppingBasketSummaryHeader = (): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { generateQuoteDocument, isDocumentLoading } = useDocumentPreview();

    return (
        <div
            className={'u-spacing-stack-s u-flex-box u-flex-box--space-between u-flex-box--center'}
        >
            <h2>{getHippoText('DSS-SUMMARY-HEADER')}</h2>
            <div className="u-flex-box u-flex-box--center u-gap-3">
                <Button
                    theme="secondary"
                    size="small"
                    iconShape="printer"
                    onClick={generateQuoteDocument}
                    disabled={isDocumentLoading}
                />
                <Link
                    className={`paragraph--small u-display-none u-display-block@xs
                         ${isDocumentLoading ? 'u-color-supplement-grey-medium' : 'u-color-primary-2-dark'}`}
                    onClick={generateQuoteDocument}
                    variant="link"
                >
                    {getHippoText('DSS-SUMMARY-PRINT')}
                </Link>
            </div>
        </div>
    );
};

export default ShoppingBasketSummaryHeader;
